import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class BodyClassService {
    private readonly rootMenuId = 'level0';
    private readonly refClassPath = [
        'homepage',
        'dashboard',
        'groups',
        'workgroups',
        'learner',
        'corpus',
        'login',
        'projects',
        'register',
        'research-sheet',
        'tools',
        'research-template',
        'forms',
        'followed',
        'section-draft',
        'ideas-wall',
        'lessons',
        'player',
        'activities'
    ];

    constructor(@Inject(DOCUMENT) private readonly document: Document) {}

    switchClassPath(menuId: string): void {
        const body = this.document.body;

        if (!body) {
            return;
        }

        const existingClasses: string[] = Array.from(body.classList);
        const preservedClass = existingClasses[0];

        body.className = '';

        if (preservedClass) {
            body.classList.add(preservedClass);
        }

        if (menuId === this.rootMenuId) {
            body.classList.remove('level1');
            body.classList.add('level0');
        } else {
            body.classList.remove('level0');
            body.classList.add('level1');
        }

        const lastPathClass = this.computeLastPathClass();

        if (lastPathClass) {
            body.classList.add(lastPathClass);
        }
    }

    private computeLastPathClass(): string | undefined {
        const location = this.document.defaultView?.location;

        if (!location) {
            return undefined;
        }

        const classList = location.pathname
            .split('/')
            .filter((path) => this.refClassPath.includes(path));

        return classList[classList.length - 1];
    }
}
